import apiSlice from './ApiSlice';

export const tagApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET CHAPTER BY ID
    getAllTags: builder.query({
        providesTags: ["tag"],
        query: () => {
          return {
            url: `/tag`,
            method: "GET",
          };
        },
      }), 
       // Add
    addTags: builder.mutation({
        invalidatesTags: ["tag"],
        query: (body) => {
          return {
            url: "/tag/add",
            method: "POST",
            body,
          };
        },
      }),
  }),
});

export const { useGetAllTagsQuery  , useAddTagsMutation  } = tagApi;